import { isGroupCreative } from '../utils';

export default function ExampleController(
  $state,
  CreativeService,
  CreativeGroupService,
  CurrentUserService,
  GeneratorMixpanelService,
  RenderService,
  RtbPixelService,
  partner
) {
  const vm = this;

  vm.partner = partner;

  CurrentUserService.get().then(user => {
    vm.user = user;
    vm.showNewAdBuilder = isGroupCreative(CreativeService.creative);
  });

  GeneratorMixpanelService.trackBuilder();

  if (!$state.params.maintainState) {
    CreativeService.resetCreative();
    CreativeGroupService.reset();
    CreativeService.setDefaultCreative(partner);
    RtbPixelService.reset();
  }

  RenderService.setSite();

  return vm;
}

ExampleController.$inject = [
  '$state',
  'CreativeService',
  'CreativeGroupService',
  'CurrentUserService',
  'GeneratorMixpanelService',
  'RenderService',
  'RtbPixelService',
  'partner'
];
